<template>
  <dynamic-object-form-structure
    :object-uuid="objectUUID"
    :object-layer="objectLayer"
    :loading-structure="loadingStructure"
    :loading-save="loadingSave"
    :permission-name="form.permission"
    :object-type-translation-key="form.name_translation"
    :tabs="visibleTabs"
    :active-tab="activeTab"
    :action-type="actionType"
    :saveIsDisabled="!required.filled"
    :map-element="$parent.$refs.formsContainer"
    :previous-pos-x="previousPosX"
    :previous-pos-y="previousPosY"
    :data-was-changed="dataWasChanged"
    :fields-still-need-filled="required.stillNeedFilled"
    @updateActiveTab="activeTab = $event"
    @changeViewMode="changeViewModeOfObject"
    @openDetails="openDetails"
    @refresh="refresh"
    @clearData="clearData"
    @save="saveObject"
    @close="closeForm"
    :object-data="objectData"
  >
    <template v-slot:formFields>
      <div
        v-show="visibleTabs[activeTab].type === 'form'"
        class="form tab-content"
      >
        <input-field
          v-for="field in visibleTabs[activeTab].fields"
          :key="visibleTabs[activeTab].code + field.label + field.order"
          ref="formInputField"
          :value="getValueInObject(field.var_name, field.input_type)"
          @input="setValueInObject(field.var_name, $event, field.input_type)"
          :label="field.label_client ? field.label_client : field.label"
          :variable-name="field.var_name"
          :inputType="field.input_type"
          :size="field.size"
          :required="field.required"
          :required-filled="required.filled"
          :selectOptions="field.select_list_name"
          :radioOptions="field.radio_options"
          :fieldDisabled="field.disable"
          :tabDisabled="!userCanEditTabContent(visibleTabs[activeTab])"
          :formDisabled="readOnly"
          :hide="field.hide"
          :automatic-label="field.has_automatic_label"
          @generateLabel="getAutomaticLabel(autoLabelRequestData)"
          :checkboxOptions="field.checkbox_options"
          :object-data="objectData"
          :labelIsLocked="objectData.clz_label_locked"
          :user-can-unlock-label="!userHasFibercloudPermission(form.permission + '_manage_label')"
          @toggle-label-lock="changeLabelMode"
          @updateCheckboxValue="updateCheckboxValue($event)"
          @removePhoto="addToPhotosToRemove($event)"
        />
      </div>
      <custom-fields-tab
        v-if="visibleTabs[activeTab].code === 'custom_fields'"
        :customFields="customFields.custom_fields"
        :objectData="objectData.custom_fields"
        :actionType="actionType"
        :disabled="readOnly"
        @updateValue="setValueInObject"
        :requiredFilled="required.filled"
      />
    </template>
  </dynamic-object-form-structure>
</template>

<script>
import { dynamicObjectFormsMixin } from "@/mixins/forms/dynamicObjectForms/dynamicObjectFormsMixin";
import DynamicObjectFormStructure from "../_Templates/DynamicObjectFormStructure";
import InputField from "../_Molecules/InputField";
import CustomFieldsTab from "@/components/Home/Forms/_SpecialTabs/CustomFields/CustomFieldsTab.vue";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  name: "PrimaryNodeForm",

  components: {
    InputField,
    DynamicObjectFormStructure,
    CustomFieldsTab
  },

  mixins: [dynamicObjectFormsMixin,checkPermissionsMixin],

  props: {
    wkt: {
      type: String
    }
  },

  computed: {
    autoLabelRequestData() {
      let request = {};
      let textGeom, projection;
      if (this.actionType === "create") {
        projection = 3857;
        textGeom = this.wkt;
      } else {
        projection = 4326;
        textGeom = this.dataReceived.clz_text_geom;
      }
      request = {
        layer: this.objectLayer,
        text_geom: textGeom,
        projection: projection
      };
      return request;
    }
  },

  methods: {
    createObject() {
      const id = Number(localStorage.getItem('zone_id'));
      this.dataToSend = {
        text_geom: this.wkt,
        projection: 3857,
        closure_id: id
      };
      this.placeObjectDataInDataToSend();
      this.CREATE_OBJECTS({
        endpoint: this.form.endpoint,
        data: [this.dataToSend]
      })
        .then(() => {
          this.finishObjectCreation();
        })
        .catch(error => {
          this.$toasted.global.toast_error(error.response.data.data);
          this.loadingSave = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/Forms/ObjectForms/ClosureAreaForm.vue